import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  Button,
  Card,
  Typography,
  CardContent,
  CardMedia,
} from "@mui/material";
import { Box } from "@mui/system";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ButtonGroup from "@mui/material/ButtonGroup";
import { map, sortBy, find } from "lodash";

import AssetList from "../../Components/List/SelectionList";
import Confirmation from "../../Components/Modal/Confirmation";
import { getPodcastInfo, getPodcastLearners, updatePodcast } from "./Services";
import { getFormatedDate, getFormatedTime } from "../../Js/TimeAndDate";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { userLogs, durationCalculate, getClassNames } from "../../Js/Common";
import RecordButtonForBroadcast from "../../Components/Media/RecordButtonForBroadcast";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../Layouts/Users/Services";
import { joinByKeys } from "../../Js/Common";
import { uploadRecordBroadcastFile } from "../../Js/Common";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

import IconButton from "@mui/material/IconButton";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import DeleteIcon from "@mui/icons-material/Delete";
import AudioButton from "../../Components/Media/AudioButton";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const PodcastRecording = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const styleclass = useStyles();
  let { id } = useParams();

  // State
  const [podcastInfo, setPodcastInfo] = useState(null);
  const [learnerList, setLearnerList] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [classes, setClasses] = useState([]);
  const [allaudioArr, setAllaudiosArr] = useState([]);
  const [fullAudioBlob, setFullAudioBlob] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // React logic hooks
  useEffect(() => {
    if (userInfo) {
      const innerFunction = async () => {
        setClasses(await getClassNames(userInfo.site_uuid));
      };
      innerFunction();
    }
  }, [userInfo]);

  useEffect(() => {
    fetchPodcastInfo();
    dispatch(assignmentSliceActions.resetState());
    //dispatch(assignmentSliceActions.setDurationFlag(false));
    //setStartTime(Date.now());
  }, [classes]);

  // Fetch Assignment Information
  const fetchPodcastInfo = async () => {
    let podcastInfoData = await getPodcastInfo(id, userInfo.site_uuid);
    setPodcastInfo(podcastInfoData.data[0]);
    let learners = await getPodcastLearners(
      podcastInfoData.data[0].context.user_uuid,
      userInfo.site_uuid,
      [true, false]
    );
    setLearnerList(
      sortBy(withClassName(learners.data), [
        "classname",
        (o) => {
          return o.name.firstname;
        },
      ])
    );
  };

  // To drop logs
  const logFunction = async (action, duration) => {
    let logResponse = await userLogs({
      actor: userInfo.uid,
      verb: "assignment",
      target: podcastInfo.uid,
      outcome: {
        value: "",
        action: action,
        duration: duration,
      },
      site_uuid: userInfo.site_uuid,
    });
  };

  const withClassName = (learners) => {
    return learners.map((val) => {
      return {
        ...val,
        classname: className(val.belongs_to),
      };
    });
  };

  const className = (id) => {
    console.log("classes", classes);
    let foundObj = find(classes, { id: id });
    if (foundObj) {
      return foundObj.value;
    }
    return "NA";
  };

  const uploadAudio = async () => {
    dispatch(commonSliceActions.setLoader(true));
    let aliasArr = userInfo.username.split("@");
    let filename = await uploadRecordBroadcastFile(
      [fullAudioBlob, ...allaudioArr],
      aliasArr[aliasArr.length - 1]
    );
    console.log("filenamefilename", filename);
    if (filename && filename.status == 200) {
      let fullAudio = null;
      let filesList = filename.data.map((value) => {
        if (value.contentType == "audio/mp3") {
          fullAudio = value.id;
          return {
            key: "fullAudio",
            name: value.id,
          };
        } else {
          return {
            key: "audioClips",
            name: value.id,
          };
        }
      });

      let updateRecord = await updatePodcast(
        {
          outcome: {
            filename: fullAudio,
            allAudioList: filesList,
            approvalStatus: null,
          },
        },
        id,
        userInfo.site_uuid
      );
      if (updateRecord && updateRecord.status == 200) {
        navigation("/Podcast");
        dispatch(commonSliceActions.setLoader(false));
      } else {
        alert("Something wrong!");
        dispatch(commonSliceActions.setLoader(false));
      }
    } else {
      alert("Something wrong!");
      dispatch(commonSliceActions.setLoader(false));
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{}}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
            pt: 2,
            pl: 3,
            pr: 7,
            pb: 2,
            overflow: "auto",
            width: "95%",
            marginLeft: 4,
            borderBottom: 1,
            borderBottomColor: "#CCCCCC",
          }}
        >
          <Grid container xs={9} sx={{}}>
            {podcastInfo && (
              <Box>
                <Typography
                  color="primary.main"
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                >
                  {podcastInfo?.context?.title
                    ? podcastInfo?.context?.title
                    : ""}
                </Typography>
                {podcastInfo?.context?.guest && (
                  <Typography
                    sx={{
                      color: "#A9A9A9",
                      fontWeight: "600",
                      fontSize: "0.8rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                  >
                    <b>Guest:</b>{" "}
                    {podcastInfo?.context?.guest
                      ? podcastInfo?.context?.guest
                      : ""}
                  </Typography>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
        <Grid
          sx={{
            pt: 3,
            pl: 3,
            pr: 7,
            height: "78vh",
            overflowY: "auto",
            textAlign: "center",
            backgroundImage: `url(/podcastbg.png)`,
            backgroundSize: "100%",
            backgroundRepeat: "no-repeat",
          }}
          className={styleclass.scrollBar}
        >
          <RecordButtonForBroadcast
            // alreadyRecorded={
            //   localAudios.length > 0 && localAudios[index]
            //     ? localAudios[index]
            //     : null
            // }
            // recordedAudio={(audio) => {
            //   setAudioLinks(audio, index);
            // }}
            // smartCheck={(data, filename) => {
            //   setSmartCheck(data, filename, index);
            // }}
            // uploadedAudioName={(filename) => {
            //   setFiles(filename, index);
            // }}
            fullAudio={(fullAudio) => {
              setFullAudioBlob(fullAudio);
            }}
            allAudios={(allaudios) => {
              setAllaudiosArr(allaudios);
            }}
            resetComponent={true}
            index={0}
            audioDisable={false}
            submitFullAudio={uploadAudio}
            mode={"fromDraft"}
            title={
              podcastInfo?.context?.title ? podcastInfo?.context?.title : ""
            }
          ></RecordButtonForBroadcast>
        </Grid>
        {/* {allaudioArr && allaudioArr.length > 0 && (
          <Button onClick={uploadAudio}>Submit</Button>
        )} */}
        {/* <Confirmation
          image="delete"
          primaryText="Delete Podcast"
          secondaryText="Do you want to delete this podcast ?"
          visible={confirmModal}
          positiveClick={deleteConfirm}
          negativeClick={() => {
            setConfirmModal(false);
          }}
          toggleModal={(flag) => setConfirmModal(flag)}
        ></Confirmation> */}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default PodcastRecording;
